"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var defaultProps = {
    debounceTime: 2000,
};
var useIsScrolling = function (props) {
    var debounceTime = __assign(__assign({}, defaultProps), props).debounceTime;
    var _a = (0, react_1.useState)(false), isScrolling = _a[0], setIsScrolling = _a[1];
    (0, react_1.useEffect)(function () {
        var debounce;
        var handleScroll = function () {
            setIsScrolling(true);
            clearTimeout(debounce);
            debounce = setTimeout(function () {
                setIsScrolling(false);
            }, debounceTime);
        };
        window.addEventListener("scroll", handleScroll);
        return function () {
            window.removeEventListener("scroll", handleScroll);
            clearTimeout(debounce);
        };
    }, [debounceTime]);
    return isScrolling;
};
exports.default = useIsScrolling;
